var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"statusEvent"},[_vm._v("Event: "+_vm._s(_vm.event.getType()))])}
var staticRenderFns = []

export { render, staticRenderFns }